import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    computed,
    inject,
    OnDestroy,
    OnInit,
    signal,
} from '@angular/core';

import { ZoomState } from '@app/admin/state/zoom.state';
import { Meeting, Webinar } from '@app/data/models';
import { TiptapZoomLinkComponent } from '@app/shared/components/tiptap-zoom-link/tiptap-zoom-link.component';
import { APP_TIPTAP_EDITOR_RENDER_AS } from '@app/shared/tokens';
import { Store } from '@ngxs/store';
import { AngularNodeViewComponent, TiptapDraggableDirective } from 'ngx-tiptap';

@Component({
    selector: 'admin-tiptap-zoom-link-container',
    templateUrl: './tiptap-zoom-link-container.component.html',
    styleUrls: ['./tiptap-zoom-link-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TiptapDraggableDirective, NgClass, TiptapZoomLinkComponent],
})
export class TiptapZoomLinkContainerComponent extends AngularNodeViewComponent implements OnDestroy, OnInit {
    cd = inject(ChangeDetectorRef);
    store = inject(Store);
    renderMode = inject(APP_TIPTAP_EDITOR_RENDER_AS);

    joinUrl = 'https://zoom.us/j/1234567890?pwd=abc123';
    password = '123456';

    get showJoinButton(): boolean {
        return this.node().attrs['showJoinButton'] === true;
    }

    get showJoinUrl(): boolean {
        return this.node().attrs['showJoinUrl'] === true;
    }

    get showCopyLinkButton(): boolean {
        return this.node().attrs['showCopyLinkButton'] === true;
    }

    get showCopyPasswordButton(): boolean {
        return this.node().attrs['showCopyPasswordButton'] === true;
    }

    get zoomId(): number {
        return this.node().attrs['zoomId'];
    }

    get isEditable() {
        return this.editor().isEditable;
    }

    get alignment() {
        return this.node().attrs['textAlign'];
    }

    get renderAs() {
        return this.node().attrs['renderAs'];
    }

    zoomMeeting: Webinar | Meeting | null = null;
    variableText = '';

    updateZoomMeetingDelegate = this.updateZoomMeeting.bind(this);

    ngOnInit(): void {
        this.editor().on('transaction', this.updateZoomMeetingDelegate);
        this.editor().on('selectionUpdate', this.updateZoomMeetingDelegate);

        this.updateZoomMeeting();
        this.cd.detectChanges();
    }

    updateZoomMeeting() {
        const zoomId = this.node().attrs['zoomId'] || 0;
        const zoomMeeting = this.store.selectSnapshot(ZoomState.getZoomMeetingById(zoomId));
        const zoomWebinar = this.store.selectSnapshot(ZoomState.getZoomWebinarById(zoomId));

        this.zoomMeeting = zoomMeeting || zoomWebinar || null;

        this.variableText = '{{ No meeting selected }}';

        if (this.zoomMeeting) {
            this.variableText = `{{ zoomLink | '${this.zoomMeeting.topic}' }}`;
        }

        this.cd.detectChanges();
    }

    ngOnDestroy(): void {
        this.editor().off('transaction', this.updateZoomMeetingDelegate);
        this.editor().off('selectionUpdate', this.updateZoomMeetingDelegate);
    }
}
